//Nur für reine UI Logik
import {Toast} from "bootstrap";
import {t} from "../i18n";

const roomtypes = [t("room_bathroom"), t("room_hall"), t("room_kitchen"), t("room_bedroom"), t("room_living")];
const exteriorDoorHeights = [ "2.01", "2.135" ];
const interiorDoorHeights = [ "2.01", "2.135" ];

//Init
$( function () {
    $( '[data-toggle="tooltip"]' ).tooltip( {
        'delay': { 'show': 500, 'hide': 0 },
        'template': '<div class="tooltip custom-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
    } ); //Tooltips global aktivieren

    $( '#roomType' ).autocomplete( {
        appendTo: "#roomTypeDropdown", minLength: 0, position: { my: "left top", at: "left bottom" }, source: roomtypes
    } ).click( function () {
        $( this ).autocomplete( "search" );
    } );

    $( '#exteriorDoorHeight' ).autocomplete( {
        appendTo: "#exteriorDoorHeightDropdown",
        minLength: 0,
        position: { my: "left top", at: "left bottom" },
        source: exteriorDoorHeights
    } ).click( function () {
        $( this ).autocomplete( "search" );
    } );

    $( '#interiorDoorHeight' ).autocomplete( {
        appendTo: "#interiorDoorHeightDropdown",
        minLength: 0,
        position: { my: "left top", at: "left bottom" },
        source: interiorDoorHeights
    } ).click( function () {
        $( this ).autocomplete( "search" );
    } );

    $( '#layer-open-button' ).on( 'click', function () {
        $( this ).toggleClass( 'open' );
        let button = $( '#layer-open-button' )[ 0 ];
        if ( $( this ).hasClass( 'open' ) ) {
            $( '#layer-controls-wrapper' ).addClass( 'open' );
            button.src = $( button ).data( 'src-open' );
        } else {
            $( '#layer-controls-wrapper' ).removeClass( 'open' );
            button.src = $( button ).data( 'src-closed' );
        }
    } );
} );

export function openSpinner( text ) {
    let spinner = $( '#spinner-container' );
    spinner.find( '#spinner-text' ).html( text );
    spinner.removeClass( 'd-none' ).addClass( 'd-flex' );
}

export function closeSpinner() {
    $( '#spinner-container' ).addClass( 'd-none' ).removeClass( 'd-flex' );
}

function messageTitle(type, fallback) {
    if (type === "Fehler" || type === "error") {
        return t("error");
    }
    if (type === "Hinweis" || type === "notice") {
        return t("notice");
    }
    return type || t(fallback);
}

export function showMessage( message, type = "Fehler" ) {
    if ( type === "Fehler" || type === "error" ) {
        showErrorMessage( message, type );
    } else {
        showToast( message, type );
    }
}

export function showErrorMessage( message, type = "Fehler" ) {
    let container = $( '#error-message-container' );
    container.find( '#error-message-text' ).text( message );
    container.removeClass( 'd-none' );
}

export function showSuccessMessage( message) {
    let container = $('#success-message-container');
    container.find( '#success-message-text' ).text( message );
    container.removeClass('d-none');
    console.log(container);
}

export function showErrorMessageWithAlternativeEvent( message, alternateEventButtonText,alternateButtonTrigger ) {
    let container = $( '#error-message-container-with-alternative-event' );
    container.find( '#error-message-text' ).text( message );
    container.find( '#alternative-event').text( alternateEventButtonText );
    //remove all click events
    container.find( '#alternative-event').off( 'click' );
    container.find( '#alternative-event').on( 'click',()=>{ 
        container.addClass( 'd-none' );
        alternateButtonTrigger() 
    });
    container.removeClass( 'd-none' );
    //container.on( 'click', alternateButtonTrigger );
}

export function showToast( message, type = "Hinweis" ) {
    let toast = $( getToast( message, type ) );
    $( '#toast-container' ).append( toast );
    new Toast( toast, { delay: 5000 } ).show();
    toast.on( 'hidden.bs.toast', function () {
        toast.remove();
    } );
}

function getToast( message, type ) {
    return `
    <div class="toast fade" role="alert" aria-live="assertive" aria-atomic="true">
        <div class="toast-header">
            <strong class="mr-auto">` + messageTitle(type, "notice") + `</strong>
            <button type="button" class="ms-auto mb-1 close" data-dismiss="toast" aria-label="Close" onclick="$(this).closest('.toast').hide()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="toast-body">
            ` + message + `
        </div>
    </div>
    `;
}
